import React from 'react';
import Hero from '../components/ui/Hero';

const PrivacyPolicy: React.FC = () => (
  <>
    <Hero
      title='ПОЛИТИКА ЗА ПОВЕРИТЕЛНОСТ'
      buttonText='Продължи надолу'
      fontSize={42}
      onButtonClick={() => window.scrollTo({ top: 768, behavior: 'smooth' })}
    />
    <section className='container my-5 text-start'>
      <div className='card shadow-sm'>
        <div className='card-body'>
          <h2 className='card-title mb-4 text-center'>
            Политика за поверителност
          </h2>
          <p>
            Настоящата Политика за поверителност има за цел да ви информира как{' '}
            <strong>„ХРИСТИЯНА ИВАНОВА“ ЕООД</strong> (наричано по-долу
            „Доставчик“) събира, използва, съхранява и защитава вашите лични
            данни при използване на уебсайта{' '}
            <a
              href='https://hristiyana-ivanova.com/'
              target='_blank'
              rel='noopener noreferrer'
            >
              https://hristiyana-ivanova.com/
            </a>
            .
          </p>
          <hr />
          <h5 className='mt-4'>
            1. Идентификация на администратора на лични данни
          </h5>
          <ul>
            <li>
              <strong>Наименование:</strong> „ХРИСТИЯНА ИВАНОВА“ ЕООД
            </li>
            <li>
              <strong>ЕИК:</strong> 208327931
            </li>
            <li>
              <strong>Адрес:</strong> България, гр. Горна Оряховица, ул. „Цар
              Освободител“ №57
            </li>
            <li>
              <strong>Имейл за контакт:</strong>{' '}
              <a href='mailto:hristiyanaivanova9222@gmail.com'>
                hristiyanaivanova9222@gmail.com
              </a>
            </li>
          </ul>
          <hr />
          <h5 className='mt-4'>2. Какви данни събираме</h5>
          <ul>
            <li>Име и фамилия</li>
            <li>Имейл адрес</li>
            <li>Телефонен номер</li>
            <li>
              Информация за извършени плащания (напр. име на титуляр, IBAN при
              банков превод)
            </li>
            <li>
              Всяка друга информация, предоставена доброволно чрез контактни
              форми, заявки за услуги или имейл кореспонденция
            </li>
          </ul>
          <hr />
          <h5 className='mt-4'>3. Цели на обработката на данните</h5>
          <ul>
            <li>Изпълнение на поръчани услуги и консултации</li>
            <li>Комуникация относно заявени услуги</li>
            <li>
              Администриране на уебсайта и подобряване на предлаганите услуги
            </li>
            <li>
              Изпращане на важни известия, свързани с услугите или Общите
              условия
            </li>
            <li>Спазване на законови задължения</li>
          </ul>
          <hr />
          <h5 className='mt-4'>4. Правно основание за обработката</h5>
          <ul>
            <li>
              Чл. 6, ал. 1, б. „б“ от GDPR – необходимост за изпълнение на
              договор, по който субектът на данни е страна
            </li>
            <li>
              Чл. 6, ал. 1, б. „в“ от GDPR – спазване на законово задължение
            </li>
            <li>
              Чл. 6, ал. 1, б. „а“ от GDPR – съгласие (за маркетингови
              съобщения, когато е приложимо)
            </li>
          </ul>
          <hr />
          <h5 className='mt-4'>5. Срок за съхранение на данните</h5>
          <p>
            Личните данни се съхраняват за срок, необходим за изпълнение на
            целите, за които са събрани, освен ако законът не изисква по-дълъг
            срок (например счетоводни документи – 10 години).
          </p>
          <hr />
          <h5 className='mt-4'>6. Предаване на трети страни</h5>
          <ul>
            <li>
              На държавни органи и институции, когато това е предвидено в закон
            </li>
            <li>
              На доставчици на счетоводни услуги, при спазване на
              конфиденциалност
            </li>
            <li>
              На доставчици на хостинг и IT поддръжка, при спазване на защита и
              поверителност
            </li>
          </ul>
          <hr />
          <h5 className='mt-4'>7. Вашите права</h5>
          <ul>
            <li>Право на достъп до личните си данни</li>
            <li>Право на коригиране на неточни данни</li>
            <li>
              Право на изтриване („право да бъдеш забравен“) в определени случаи
            </li>
            <li>Право на ограничаване на обработването</li>
            <li>Право на преносимост на данните</li>
            <li>Право на възражение срещу обработката</li>
            <li>
              Право да подадете жалба до Комисията за защита на личните данни
              (КЗЛД) –{' '}
              <a
                href='https://www.cpdp.bg'
                target='_blank'
                rel='noopener noreferrer'
              >
                www.cpdp.bg
              </a>
            </li>
          </ul>
          <hr />
          <h5 className='mt-4'>8. Защита на данните</h5>
          <p>
            Доставчикът прилага подходящи технически и организационни мерки за
            защита на личните данни срещу неправомерен достъп, разкриване,
            промяна или унищожаване.
          </p>
          <hr />
          <h5 className='mt-4'>9. Бисквитки (Cookies)</h5>
          <p>
            Уебсайтът използва бисквитки за подобряване на потребителското
            изживяване. С използването на сайта вие се съгласявате с нашата
            политика за бисквитки. Повече за тях можете да прочетете в отделната
            Политика за бисквитки на сайта.
          </p>
          <hr />
          <h5 className='mt-4'>10. Контакти</h5>
          <p>
            За въпроси относно настоящата Политика за поверителност или за
            упражняване на вашите права, моля свържете се на:{' '}
            <a href='mailto:hristiyanaivanova9222@gmail.com'>
              hristiyanaivanova9222@gmail.com
            </a>
          </p>
          <hr />
          <p className='text-muted small'>
            Настоящата Политика за поверителност е в сила от датата на нейното
            публикуване на{' '}
            <a
              href='https://hristiyana-ivanova.com/'
              target='_blank'
              rel='noopener noreferrer'
            >
              https://hristiyana-ivanova.com/
            </a>
            .
          </p>
        </div>
      </div>
    </section>
  </>
);

export default PrivacyPolicy;
